import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

// Change orders for the list page and the detail header.
class ChangeOrderEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ChangeOrder";
        this.primaryEnterpriseComponent = "ChangeOrder";

        const eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ChangeOrder";
        eom.enterpriseComponent = "ChangeOrder";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ChangeOrderEnterpriseObjectMetadata;
